"use client"

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Phone, MessageCircle, Clock, Globe, Video } from "lucide-react"

export default function Contact() {
  const contactInfo = [
    {
      icon: Phone,
      title: "Телефон",
      content: "+7 (922) 626-80-52",
      description: "Звонки принимаю с 9:00 до 21:00",
    },
    {
      icon: MessageCircle,
      title: "WhatsApp",
      content: "+7 (922) 626-80-52",
      description: "Быстрая связь и запись на сессию",
      action: () => window.open("https://wa.me/79226268052", "_blank"),
    },
    {
      icon: MessageCircle,
      title: "Telegram",
      content: "@OxanaZayakina",
      description: "Личные сообщения и консультации",
      action: () => window.open("https://t.me/OxanaZayakina", "_blank"),
    },
    {
      icon: Clock,
      title: "Часы работы",
      content: "06:00 - 20:00, без выходных",
      description: "Московское время (UTC+3)",
    },
  ]

  const platforms = [
    { icon: Video, name: "Google Meet", description: "Основная платформа" },
    { icon: Phone, name: "Telegram", description: "Для быстрой связи" },
    { icon: MessageCircle, name: "WhatsApp", description: "Голосовые/видео звонки" },
  ]

  return (
    <section id="contact" className="py-12 sm:py-16 lg:py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12">
          {/* Contact Information */}
          <div className="space-y-4 sm:space-y-6">
            <h3 className="text-xl sm:text-2xl font-semibold text-slate-900 mb-4 sm:mb-6">Контактная информация</h3>
            {contactInfo.map((item, index) => (
              <Card
                key={index}
                className={`border-slate-200 hover:shadow-md transition-all duration-300 bg-white ${
                  item.action ? "cursor-pointer hover:border-indigo-300" : ""
                }`}
                onClick={item.action}
              >
                <CardContent className="p-4 sm:p-6">
                  <div className="flex items-start gap-3 sm:gap-4">
                    <div className="p-2 sm:p-3 bg-indigo-100 rounded-full flex-shrink-0">
                      <item.icon className="h-5 w-5 sm:h-6 sm:w-6 text-indigo-600" />
                    </div>
                    <div className="min-w-0 flex-1">
                      <h4 className="font-semibold text-slate-900 mb-1 sm:mb-2 text-sm sm:text-base">{item.title}</h4>
                      <p className="text-slate-700 whitespace-pre-line mb-1 text-sm sm:text-base break-words">
                        {item.content}
                      </p>
                      <p className="text-xs sm:text-sm text-slate-500">{item.description}</p>
                      {item.action && <p className="text-xs sm:text-sm text-indigo-600 mt-1">Нажмите для перехода</p>}
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Platforms */}
          <div>
            <h3 className="text-xl sm:text-2xl font-semibold text-slate-900 mb-4 sm:mb-6">Платформы для сессий</h3>
            <div className="grid grid-cols-2 gap-3 sm:gap-4 mb-6 sm:mb-8">
              {platforms.map((platform, index) => (
                <Card
                  key={index}
                  className="border-slate-200 hover:shadow-md transition-all duration-300 group bg-white"
                >
                  <CardContent className="p-4 sm:p-6 text-center">
                    <platform.icon className="h-6 w-6 sm:h-8 sm:w-8 text-indigo-600 mx-auto mb-2 sm:mb-3 group-hover:scale-110 transition-transform" />
                    <h4 className="font-semibold text-slate-900 mb-1 text-sm sm:text-base">{platform.name}</h4>
                    <p className="text-xs sm:text-sm text-slate-600">{platform.description}</p>
                  </CardContent>
                </Card>
              ))}
            </div>

            <Card className="bg-indigo-50 border-indigo-200">
              <CardHeader>
                <CardTitle className="text-slate-900 flex items-center gap-2 text-base sm:text-lg">
                  <Globe className="h-4 w-4 sm:h-5 sm:w-5 text-indigo-600" />
                  Онлайн-консультации по всему миру
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-slate-700 leading-relaxed text-sm sm:text-base mb-4">
                  Провожу сессии для клиентов из любой точки мира. Главное - стабильное интернет-соединение и желание
                  работать над собой. Подстраиваюсь под ваш часовой пояс и удобное время.
                </p>
                <p className="text-sm text-slate-600 font-medium">
                  💬 Для быстрой связи пишите в WhatsApp или Telegram
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  )
}
